import Dexie from 'dexie';

export class DexieService extends Dexie {
    constructor() {
        super('max_payroll_db');
        this.version(1).stores({
            designations: '++id',
            payroll: '++id',
            employee: '++id',
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/theme/pages/default/designation/core/dexie.service.ts